import React from "react";

const SkillBar = ({ skill }) => {
  const { name, value } = skill;
  return (
    <div>
      <div className="relative w-full xl:mt-8 mt-4">
        <label
          id="p01c-label"
          htmlFor="p01c"
          className="block mb-2 text-base text-left ml-2 text-white"
        >
          {name}
        </label>

        <div className="flex w-full gap-2 justify-between">
          <label
            id="p01c-label"
            htmlFor="p01c"
            className="order-2 mb-0 text-xs text-center text-white "
          >
            <span className="sr-only">uploading</span> {value}%
          </label>
          <progress
            aria-labelledby="p01c-label"
            id="p01c"
            max="100"
            value={value}
            className="block w-11/12 overflow-hidden rounded-lg bg-slate-400 [&::-webkit-progress-bar]:bg-slate-400 [&::-webkit-progress-value]:bg-white [&::-moz-progress-bar]:bg-white"
          >
            {value}
          </progress>
        </div>
      </div>
    </div>
  );
};

export default SkillBar;
